export default {
  login: "cassidoo",
  id: 1454517,
  node_id: "MDQ6VXNlcjE0NTQ1MTc=",
  avatar_url: "https://avatars2.githubusercontent.com/u/1454517?v=4",
  gravatar_id: "",
  url: "https://api.github.com/users/cassidoo",
  html_url: "https://github.com/cassidoo",
  followers_url: "https://api.github.com/users/cassidoo/followers",
  following_url: "https://api.github.com/users/cassidoo/following{/other_user}",
  gists_url: "https://api.github.com/users/cassidoo/gists{/gist_id}",
  starred_url: "https://api.github.com/users/cassidoo/starred{/owner}{/repo}",
  subscriptions_url: "https://api.github.com/users/cassidoo/subscriptions",
  organizations_url: "https://api.github.com/users/cassidoo/orgs",
  repos_url: "https://api.github.com/users/cassidoo/repos",
  events_url: "https://api.github.com/users/cassidoo/events{/privacy}",
  received_events_url: "https://api.github.com/users/cassidoo/received_events",
  type: "User",
  site_admin: false,
  name: "Cassidy Williams",
  company: "@Netlify",
  blog: "https://cassidoo.co",
  location: "Chicago, IL",
  email: null,
  hireable: null,
  bio: "Making memes and dreams... and software",
  twitter_username: "cassidoo",
  public_repos: 99,
  public_gists: 24,
  followers: 7347,
  following: 97,
  created_at: "2012-02-20T16:36:23Z",
  updated_at: "2021-01-02T00:59:27Z",
};
